export const API_ENDPOINT = 'https://www.mangomist.com/';